import React, { useEffect, useRef } from "react";
import ChatRoom from "./ChatRoom";
import VideoArea from "./VideoArea";
import UserInfoForm from "./UserInfoForm";
import RightContentWrapper from "./RightContentWrapper";
import { useDispatch, useSelector } from "react-redux";
import './style.css';
import { URL } from "../../variables";
import { logout } from "../../actions/AppActions";
import axios from "axios";
import moment from "moment";
const MODE_STREAM = "stream";
const MODE_SHARE_SCREEN = "share_screen";

const configuration = {
  iceServers: [
    { urls: "stun:stun.1.google.com:19302" },
    {
      'urls': 'turn:turnserver.ontest.com.br:3478?transport=udp',
      'credential': 'Coconuts69341228#',
      'username': 'onteste_projetos'
    },
  ],
  sdpSemantics: 'unified-plan'
};

let silence = () => {
  let ctx = new AudioContext(), oscillator = ctx.createOscillator();
  let dst = oscillator.connect(ctx.createMediaStreamDestination());
  oscillator.start();
  return Object.assign(dst.stream.getAudioTracks()[0], { enabled: false });
}

let black = ({ width = 320, height = 240 } = {}) => {
  let canvas = Object.assign(document.createElement("canvas"), { width, height });
  var context = canvas.getContext("2d");
  canvas.getContext('2d').fillRect(0, 0, width, height);
  context.beginPath();
  context.fillStyle = "blue";
  context.arc(0, 0, width / 2, 0, 2 * Math.PI, false);
  context.fill();
  context = canvas.getContext("2d");

  context.font = '9pt';
  context.fillStyle = 'white';
  context.textAlign = 'center';
  context.fillText('amit', 0, 0 + 4);
  let stream = canvas.captureStream();
  return Object.assign(stream.getVideoTracks()[0], { enabled: false });
}

let videodata = []
let screendata = []
let mediaRecorder = null;
let mediaRecorder_2 = null;

export default function MeetingRoom(props) {
  // console.log(props)
  const [focused_participant, setFocusedParticipant] = React.useState(null);
  let userSocket = null;

  const localScreen = React.useRef();
  const localStreamScreen = React.useRef();

  const participants = React.useRef();

  const isConnectedRef = React.useRef();
  const [show_chat, setShowChat] = React.useState(false);
  const [show_info, setShowInfo] = React.useState(false);

  const [show_participants, setShowParticipants] = React.useState(true);
  const timeout_join = useRef();

  const localVideo = React.useRef();
  const localStream = React.useRef();
  const clientId = React.useRef();
  const device = React.useRef();
  const producerTransport = React.useRef();
  const videoProducer = React.useRef({});
  const audioProducer = React.useRef({});
  const consumerTransport = React.useRef();
  const videoConsumers = React.useRef({});
  const audioConsumers = React.useRef({});
  const consumersStream = React.useRef({});
  const list_peers = React.useRef();

  const [loading_timer, setLoadingTimer] = React.useState(false);

  const dispatch = useDispatch();
  const timeout_video_save = useRef();
  const timeout_screen_save = useRef();
  const [useVideo, setUseVideo] = React.useState(true);
  const [devicesMic, setDevicesMic] = React.useState([]);
  const [devicesCam, setDevicesCam] = React.useState([]);
  const [deviceCamSelect,setDeviceCamSelect] = React.useState('');
  const [deviceMicSelect,setDeviceMicSelect] = React.useState('');



  const [useAudio, setUseAudio] = React.useState(true);
  const [isStartMedia, setIsStartMedia] = React.useState(false);
  const [isConnected, setIsConnected] = React.useState(false);
  const [remoteVideos, setRemoteVideos] = React.useState({});
  const [isShareScreen, setIsShareScreen] = React.useState(false);
  const [roomName, setRoomName] = React.useState("");
  const [username, setUsername] = React.useState("");
  const [start_media, setStartMedia] = React.useState(true);

  const [messageWarning, setMessageWarning] = React.useState("");

  // ============ STREAMING CONTROL START ==========
  const [enableVideoStream, setEnableVideoStream] = React.useState(useVideo);
  const [enableAudioStream, setEnableAudioStream] = React.useState(useAudio);

  const [enableVideoShare, setEnableVideoShare] = React.useState(useVideo);
  const [enableAudioShare, setEnableAudioShare] = React.useState(useAudio);

  const socket = useSelector(store => store.AppReducer.socket);
  const token = useSelector(store => store.AppReducer.token);

  const connect = useSelector(store => store.AppReducer.connect);

  const user = useSelector(store => store.AppReducer.user);

  const seconds_diff = useRef();
  const timeout_get_time = useRef();
  const timeout_increment = useRef();
  const timers = useRef();




  // console.log(props.student)

  const calculateTimer = () => {
    let time_in_seconds = 0;
    let type = 'pause';
    let last_time = null
    timers.current.map((item, id) => {
      if (item.type == 'play') {
        last_time = item;
        type = 'play';
      }
      else if (item.type == 'pause') {
        time_in_seconds += moment(item.created_at).diff(moment(last_time.created_at), 'seconds');
        type = 'pause';
      }
    })
    // console.log(timers.current)
    if (type == 'play') {
      time_in_seconds += moment().add(seconds_diff.current, 'seconds').diff(moment(last_time.created_at), 'seconds');
    }
    // console.log(time_in_seconds)
    var currentHours = Math.floor((time_in_seconds / 60) / 60);
    var currentMinutes = Math.floor(time_in_seconds / 60) - currentHours * 60

    var currentSeconds = time_in_seconds % 60;
    if (currentSeconds <= 9) currentSeconds = "0" + currentSeconds;
    if (currentMinutes <= 9) currentMinutes = "0" + currentMinutes;
    if (currentHours <= 9) currentHours = "0" + currentHours;
    if (document.getElementById('timer_exam')) {
      const timerElement = document.getElementById('timer_exam');
      const timerLabel = timerElement.dataset.label || 'Tempo de Avaliação';
      timerElement.innerText = timerLabel + ': ' + currentHours + ":" + currentMinutes + ":" + currentSeconds;
      if (type == 'play') {
        timerElement.className = 'blink_timer';
      }
      else {
        timerElement.className = '';
      }
    }
    timeout_increment.current = setTimeout(() => {
      calculateTimer()
    }, 1000)
  }

  const get_time_server = (first = true) => {

    fetch(`${URL}api/get_time_server`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',

        'Authorization': `Bearer ${token}`,
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');
          // this.setState({redirect:true,path:'/'});
          dispatch(logout())
          return;
        }
        else {
          if (resp.atual != null) {
            seconds_diff.current = moment(resp.atual).diff(moment(), 'seconds');

            if (first == true) {
              if (!timers.current) {
                timers.current = props.student.timers;
              }
              calculateTimer()
            }

          }
        }
        timeout_get_time.current = setTimeout(() => {
          get_time_server(false);
        }, 30000);
      } catch (err) {
        console.log(err);
        timeout_get_time.current = setTimeout(() => {
          get_time_server(first);
        }, 30000);
      }

    })
      .catch((err) => {
        console.log(err);
        timeout_get_time.current = setTimeout(() => {
          get_time_server(first);
        }, 5000);
      });
  }


  const options = {
    // mimeType:this.props.processo.mobile==true?'video/webm': "video/webm;codecs=vp8,vp9,opus",
    mimeType: props.processo.mobile == true ? 'video/webm' : "video/webm;codecs=h264",
    audioBitsPerSecond: 10000,
    videoBitsPerSecond: 500,
    bitsPerSecond: 500
  };
  const options_screen = {
    // mimeType:this.props.processo.mobile==true?'video/webm': "video/webm;codecs=vp8,vp9,opus",
    mimeType: props.processo.mobile == true ? 'video/webm' : "video/webm;codecs=h264",
    videoBitsPerSecond: 500000,
    bitsPerSecond: 500000,
    audioBitsPerSecond: 10000,
  };

  const replaceVideoTracks = (type, id_track, new_track) => {
    Object.keys(list_peers.current).map((key) => {
      if (list_peers.current[key] != undefined) {
        list_peers.current[key].getSenders().map(async (sender) => {
          if (sender.track.kind == type && id_track == sender.track.id) {
            await sender.replaceTrack(new_track)
          }
          return sender;
        })
      }
    })
  }

  useEffect(() => {
    timers.current = props.student.timers;
  }, [props.student])



  const handleEnableVideoStream = async (stream, cond,force=false) => {
    if (!stream) {
      return false;
    }
    if (participants.current[props.getAdminId()] == undefined) {
      participants.current[props.getAdminId()] = {
        ...user, id: props.getAdminId(), type: 'Avaliador',
        stream: stream,
        video_track_cam: null,
        video_track_screen: null,
        audio_track: null,
        video_cam: enableVideoStream, audio: enableAudioStream, screen: isShareScreen
      }
    }

    if (cond == false && force==false) {
      stream.getVideoTracks()[0].stop();
      let stream_new = new MediaStream();
      stream_new.addTrack(black());
      stream_new.addTrack(stream.getVideoTracks()[1]);
      stream_new.addTrack(stream.getAudioTracks()[0]);

      console.log('stop')
      participants.current[props.getAdminId()].video_cam = false;
      participants.current[props.getAdminId()].video_track_cam = stream_new.getVideoTracks()[0];

      participants.current[props.getAdminId()].stream = stream_new;
        localStream.current = stream_new;
        consumersStream.current = stream_new;

      let remotes = { ...participants.current }
      setRemoteVideos(remotes);
      setEnableVideoStream(cond);
      if (mediaRecorder) {
        clearTimeout(timeout_video_save.current);
        mediaRecorder.stop();
      }
      if (isConnected) {
        replaceVideoTracks('video',stream.getVideoTracks()[0].id,stream_new.getVideoTracks()[0]);
        socket.emit('update_config_call', { 
          
          name: participants.current[props.getAdminId()].name,
                id: participants.current[props.getAdminId()].id,
                audio: participants.current[props.getAdminId()].audio,

                screen: participants.current[props.getAdminId()].screen,
                type: participants.current[props.getAdminId()].type,
          video_cam: cond, aluno_id: props.student.id, processo_id: props.processo.id });
      }
    }
    else {
      console.log(localStorage.getItem("deviceId"))
      navigator.mediaDevices.getUserMedia({
        video: {
          width: 320,
          height: 240,
          
          facingMode: "user",
          frameRate: 15,
          ...localStorage.getItem("deviceId")?{deviceId:{exact:localStorage.getItem("deviceId")}}:{}
        },
        audio:false
      }).then((stream_new) => {

        participants.current[props.getAdminId()].video_cam = true;
        participants.current[props.getAdminId()].video_track_cam = stream_new.getVideoTracks()[0];
        if (isConnected) {
        }
        stream_new.addTrack(stream.getVideoTracks()[1]);
        stream_new.addTrack(stream.getAudioTracks()[0]);

        participants.current[props.getAdminId()].stream = stream_new;
        localStream.current = stream_new;
        consumersStream.current = stream_new;

        let remotes = { ...participants.current }
        if (isConnected == true) {
          replaceVideoTracks('video', stream.getVideoTracks()[0].id, stream_new.getVideoTracks()[0]);
          socket.emit('update_config_call', { 
            name: participants.current[props.getAdminId()].name,
                id: participants.current[props.getAdminId()].id,
                audio: participants.current[props.getAdminId()].audio,
                screen: participants.current[props.getAdminId()].screen,
                type: participants.current[props.getAdminId()].type,
            
            video_cam: cond, aluno_id: props.student.id, processo_id: props.processo.id });
        }
        else {
          localVideo.current.srcObject = stream_new;
        }
        // stream.getVideoTracks()[0].stop();

        stream.getVideoTracks()[0].stop();

        setRemoteVideos(remotes);
        setEnableVideoStream(cond);
        loadDevices();
        console.log(stream_new.getTracks())

        if (mediaRecorder) {
          clearTimeout(timeout_video_save.current);
          console.log('stop video')
          mediaRecorder.stop();
        }
      }).catch((e) => {
localStorage.removeItem("deviceId");
      })


    }
    // stream.getVideoTracks()[0].enabled = cond;
  };
  const handleEnableAudioStream = (stream, cond,force=false) => {
    stream = localStream.current;
    console.log('tracks',localStream.current.getTracks())
    if (!stream) {
      return false;
    }
      // let has_audio = stream.getAudioTracks().length?true:false;

    if (participants.current[props.getAdminId()] == undefined) {
      participants.current[props.getAdminId()] = {
        ...user, id: props.getAdminId(), type: 'Avaliador',
        stream: stream,
        video_track_cam: null,
        video_track_screen: null,
        audio_track: null,
        video_cam: enableVideoStream, audio: enableAudioStream, screen: isShareScreen
      }
    }
    if ((stream.getAudioTracks()[0].readyState == "ended" && cond == true) || force) {
      console.log('aquiii',cond,force,stream.getAudioTracks()[0].readyState)
      navigator.mediaDevices.getUserMedia({ audio: localStorage.getItem('deviceIdMic')?{deviceId:{exact:localStorage.getItem('deviceIdMic')??''}}:true }).then((stream_new) => {
        participants.current[props.getAdminId()].audio = cond;
        stream.getAudioTracks()[0].enabled = cond;
        stream_new.addTrack(stream.getVideoTracks()[0])
        loadDevices();

        stream_new.addTrack(stream.getVideoTracks()[1])
        if (isConnected) {
          replaceVideoTracks('audio', stream.getAudioTracks()[0].id, stream_new.getAudioTracks()[0]);
          socket.emit('update_config_call', {  
            name: participants.current[props.getAdminId()].name,
                id: participants.current[props.getAdminId()].id,
                video_cam: participants.current[props.getAdminId()].video_cam,
                screen: participants.current[props.getAdminId()].screen,
                type: participants.current[props.getAdminId()].type,
            audio: cond, aluno_id: props.student.id, processo_id: props.processo.id });
        }

        participants.current[props.getAdminId()].stream = stream_new;
        participants.current[props.getAdminId()].audio_track = stream_new.getAudioTracks()[0];
        stream.getAudioTracks()[0].stop();
        localStream.current = stream_new;
        consumersStream.current = stream_new;
        let remotes = { ...participants.current }
        console.log('console tracks', stream_new.getTracks())

        setRemoteVideos(remotes);
        setEnableAudioStream(cond);
        if (mediaRecorder) {
          clearTimeout(timeout_video_save.current);
          mediaRecorder.stop();
        }
      }).catch((e) => {
        console.log(e)
        localStorage.removeItem("deviceIdMic");

      })
    }
    else {
      console.log('aquiii2')

      console.log('end')
      participants.current[props.getAdminId()].audio = cond;
      console.log(participants.current[props.getAdminId()])
      console.log('aquiiiiiii1')

      stream.getAudioTracks()[0].enabled = cond;
      console.log('aquiiiiii2')

      let remotes = { ...participants.current }

      if (isConnected) {
        socket.emit('update_config_call', { 
          name: participants.current[props.getAdminId()].name,
                id: participants.current[props.getAdminId()].id,
                video_cam: participants.current[props.getAdminId()].video_cam,
                screen: participants.current[props.getAdminId()].screen,
                type: participants.current[props.getAdminId()].type,
          audio: cond, aluno_id: props.student.id, processo_id: props.processo.id });
      }
      console.log('aquiiiiiii')
      setRemoteVideos(remotes);
      setEnableAudioStream(cond);

    }



  };
  const handleEnableVideoShare = (stream, cond) => {
    if (!stream) {
      return false;
    }
    stream.getVideoTracks()[0].enabled = cond;
    setEnableVideoShare(cond);
  };
  const handleEnableAudioShare = (stream, cond) => {
    if (!stream) {
      return false;
    }
    stream.getAudioTracks()[0].enabled = cond;
    setEnableAudioShare(cond);
  };

  // ============STREAMING CONTROL END ==========
  // ============ ROOM START ==========

  const handleRoomName = (e) => {
    setRoomName(e.target.value);
  };

  const handleUsername = (e) => {
    setUsername(e.target.value);
  };
  // ============ ROOM END ==========

  // ============ SHARE SCREEN START ==========
  const handleStartScreenShare = () => {
    if (localStreamScreen.current) {
      console.warn("WARN: local media ALREADY started");
      return;
    }

    const mediaDevices = navigator.mediaDevices;
    mediaDevices
      .getDisplayMedia({
        video: {
          width: 800,
          // height: 320,
          frameRate: 15,
        }
      })
      .then((stream) => {
        localStreamScreen.current = stream;

        // playVideo(localScreen.current, localStreamScreen.current, 0);
        handleConnectScreenShare();
        const screenTrack = stream.getVideoTracks()[0];
        screenTrack.onended = function () {
          handleDisconnectScreenShare();
        };


        participants.current[props.getAdminId()].video_show = 'screen';
        participants.current[props.getAdminId()].screen = true;
        participants.current[props.getAdminId()].video_track_screen = screenTrack;
        let stream_new = new MediaStream();
        let track_old = participants.current[props.getAdminId()].stream.getVideoTracks()[1];

        stream_new.addTrack(participants.current[props.getAdminId()].stream.getAudioTracks()[0]);
        stream_new.addTrack(participants.current[props.getAdminId()].stream.getVideoTracks()[0]);
        stream_new.addTrack(screenTrack);


        participants.current[props.getAdminId()].stream = stream_new;
        localStream.current = stream_new;
        consumersStream.current = stream_new;
        init_media_recorder_screen();

        let remotes = { ...participants.current }
        replaceVideoTracks('video', track_old.id, screenTrack);
        track_old.stop();
        // else{
        // localVideo.current.srcObject=stream_new;
        // }
        setRemoteVideos(remotes);
        setIsShareScreen(true);
        socket.emit('update_config_call', {  
          name: participants.current[props.getAdminId()].name,
                id: participants.current[props.getAdminId()].id,
                video_cam: participants.current[props.getAdminId()].video_cam,
                audio: participants.current[props.getAdminId()].audio,

                screen: participants.current[props.getAdminId()].screen,
                type: participants.current[props.getAdminId()].type,
          aluno_id: props.student.id, processo_id: props.processo.id });


      })
      .catch((err) => {
        console.error("media ERROR:", err);
      });
  };

  async function handleConnectScreenShare() {
    if (!localStreamScreen.current) {
      console.warn("WARN: local media NOT READY");
      return;
    }

    // // --- connect socket.io ---
    // await connectSocket().catch((err: any) => {
    //     console.error(err);
    //     return;
    // });

    // console.log('connected');

    // --- get capabilities --

  }

  useEffect(() => {
    isConnectedRef.current = isConnected;
  }, [isConnected])

  function handleStopScreenShare() {
    if (localStreamScreen.current) {
      stopLocalStream(localStreamScreen.current);
      localStreamScreen.current = null;
      setIsShareScreen(false);
    }
  }
  async function handleDisconnectScreenShare() {
    if (participants.current[props.getAdminId()] != undefined) {

      participants.current[props.getAdminId()].screen = false;
      if (participants.current[props.getAdminId()].video_track_screen != null) {
        participants.current[props.getAdminId()].video_track_screen.stop();
      }
      participants.current[props.getAdminId()].video_track_screen = null;
      participants.current[props.getAdminId()].video_show = 'camera';

      localStreamScreen.current = null;
      let remotes = { ...participants.current }
      // else{
      // localVideo.current.srcObject=stream_new;
      // }
      setRemoteVideos(remotes);
      setIsShareScreen(false);
      socket.emit('update_config_call', { 
        name: participants.current[props.getAdminId()].name,
                id: participants.current[props.getAdminId()].id,
                video_cam: participants.current[props.getAdminId()].video_cam,
                audio: participants.current[props.getAdminId()].audio,

                screen: participants.current[props.getAdminId()].screen,
                type: participants.current[props.getAdminId()].type,
        aluno_id: props.student.id, processo_id: props.processo.id });
      if (mediaRecorder_2) {
        clearTimeout(timeout_screen_save.current);
        mediaRecorder_2.stop();
      }

    }

  }

  const loadDevices = async(e)=>{
    var devices = await navigator.mediaDevices.enumerateDevices();
        let device_local = localStorage.getItem("deviceId")
        let device_local_mic = localStorage.getItem("deviceIdMic")

        console.log(devices);
        let exists = false;
        let devices_camera = [];
        let devices_mic = [];
        var _stream = null;
        let devices_cam_id = []
        let devices_mic_id = []
        let exists_mic = false;

        for (let i = 0; i < devices.length; i++) {
          if (devices[i].kind == 'videoinput') {
            if (!devices_cam_id.includes(devices[i].deviceId)) {
              devices_camera.push(devices[i]);
              devices_cam_id.push(devices[i].deviceId);

            }
            if (device_local == devices[i].deviceId) {
              exists = true;
            }
          }
          else if (devices[i].kind == 'audioinput') {
            if (!devices_mic_id.includes(devices[i].deviceId)) {
              devices_mic.push(devices[i]);
              devices_mic_id.push(devices[i].deviceId);

            }
            if (device_local_mic == devices[i].deviceId) {
              exists_mic = true;
            }
          }

        }

        let use = '';
            let use_mic=''

            if (exists == true) {
                use = device_local;
            }
            else {
                localStorage.setItem("deviceId", devices_camera[0]?.deviceId);
                use = devices_camera[0]?.deviceId;
            }

            if (exists_mic == true) {
                use_mic = device_local_mic;
            }
            else {
                localStorage.setItem("deviceIdMic", devices_mic[0]?.deviceId);
                use_mic = devices_mic[0]?.deviceId;
            }

        setDevicesCam(devices_camera)
        setDevicesMic(devices_mic)
        setDeviceMicSelect(use_mic)
        setDeviceCamSelect(use)
        console.log(devices_camera,devices_mic)

  }

  // ============ SHARE SCREEN END ==========

  // ============ MEDIA START ==========
  const handleStartMedia = async() => {
    if (localStream.current) {
      setIsStartMedia(true);

      console.warn("WARN: local media ALREADY started");
      return;
    }
    list_peers.current = {}
    participants.current = {}
    consumersStream.current = {}
    console.log('starting media');
    setStartMedia(false)

    let device_local = localStorage.getItem("deviceId")
        let device_local_mic = localStorage.getItem("deviceIdMic")

        setIsStartMedia(true);
        setEnableAudioStream(false);
        setEnableVideoStream(false);
        localStorage.removeItem("deviceId");
        localStorage.removeItem("deviceIdMic");
        // console.error("media ERROR:", err);
        let stream = new MediaStream();
        if (stream.getAudioTracks().length == 0) {
          let track = silence();
          track.stop();
          stream.addTrack(track)
        }
        for (let i = stream.getVideoTracks().length; i < 2; i++) {
          let track = black();
          // track.stop();
          stream.addTrack(track)
        }
        localStream.current=stream;
        console.log(localStream.current.getTracks())
    

    // navigator.mediaDevices
    //   .getUserMedia({
    //     audio: useAudio?(device_local_mic?{deviceId:{exact:device_local_mic ?? ''}}:true):false, video: useVideo == true ? {
    //       width: 320,
    //       height: 240,
    //       facingMode: "user",
    //       frameRate: 15,
    //       ...device_local?{deviceId:{exact:device_local}}:{},
    //     } : false
    //   })
    //   .then(async (stream) => {
    //     localStream.current = stream;
    //     playVideo(localVideo.current, localStream.current, 0)?.then(() => {
    //     })?.catch((err) => {
    //     });
    //     setEnableAudioStream(true);
    //     setEnableVideoStream(true);
    //     setIsStartMedia(true);
    //     loadDevices();
        
    //   })
    //   .catch((err) => {
        
    //   });
  };

  function handleStopMedia() {
    if (localStream.current) {
      console.log('stop media')
      stopLocalStream(localStream.current);
      localStream.current = null;
      setIsStartMedia(false);
    }
  }

  function handleDisconnect() {
    if (isConnected) {
      socket.emit('exit_call', { aluno_id: props.student.id, processo_id: props.processo.id, id: props.getAdminId() })
    }
    handleStopMedia();
    handleStopScreenShare();
    setShowChat(false);
    setFocusedParticipant(null);
    disconnectSocket();
    setIsConnected(false);
    setLoadingTimer(false);
   


    if (mediaRecorder != null 
      // && mediaRecorder.state != 'inactive'
    ) {
      clearTimeout(timeout_video_save.current)
      mediaRecorder.stop();
    }

    if (mediaRecorder_2 != null 
      // && mediaRecorder_2.state != 'inactive'
    ) {
      clearTimeout(timeout_screen_save.current)
      mediaRecorder_2.stop();
    }
    isConnectedRef.current = false;
    localStream.current=null;

    if (socket != null) {

      socket.off('connect', connect_event)

      socket.off('disconnect', disconnect_event)
      socket.removeAllListeners('join_call');
      socket.removeAllListeners('new_participant');
      socket.removeAllListeners('remove_participant');
      socket.removeAllListeners('candidate_call');
      socket.removeAllListeners('sdp_call');
      socket.removeAllListeners('desc_call');
      socket.removeAllListeners('answer_call');
      socket.removeAllListeners('update_config_call');
    }

     Object.values((list_peers.current)).map((item)=>{
      item.close();
    })

    list_peers.current = {}
    participants.current = {}
    consumersStream.current = {}
  }

  function playVideo(element, stream, volume = 0) {
    try {

      // if (element.srcObject) {
      //   console.warn("element ALREADY playing, so ignore");
      //   return;
      // }
      element.srcObject = stream;
      // console.log(element);
      // console.log(stream);

      element.volume = volume;
      if (element) {
        return element.play();

      }
    }
    catch (e) {

    }
  }

  function pauseVideo(element) {
    try {
      element.pause();
      element.srcObject = null;
    } catch (err) {
      console.error("pauseVideo ERROR:", err);
    }
  }

  function stopLocalStream(stream) {
    let tracks = stream.getTracks();
    if (!tracks) {
      console.warn("NO tracks");
      return;
    }

    tracks.forEach((track) => track.stop());
  }

  function addRemoteTrack(id, track, mode) {
  }

  // function addRemoteVideo(id) {
  //   let existElement = findRemoteVideo(id);
  //   if (existElement) {
  //     console.warn("remoteVideo element ALREADY exist for id=" + id);
  //     return existElement;
  //   }

  //   let element = document.createElement("video");
  //   return element;
  // }

  // function findRemoteVideo(id) {
  //   let element = remoteVideos.current[id];
  //   return element;
  // }

  // function removeRemoteVideoByMode(id: any, mode: string) {
  //     console.log(' ---- removeRemoteVideo() id=' + id);
  //     delete consumersStream.current[id][mode];
  //     setRemoteVideos((peers: any) => {
  //         const newPeers: any = peers;
  //         delete newPeers[id][mode];

  //         return { ...peers, ...newPeers };
  //     });
  // }

  function removeRemoteVideo(id, mode) {
    console.log(" ---- removeRemoteVideo() id=" + id);
    if (mode == MODE_STREAM) {
      delete consumersStream.current[id];
    } else {
      delete consumersStream.current[id][mode];
    }

    setRemoteVideos((peers) => {
      const newPeers = peers;
      delete newPeers[id];

      return { ...consumersStream.current };
    });
    // if (element) {
    //     element.pause();
    //     element.srcObject = null;
    //     remoteContainer.removeChild(element);
    // } else {
    //     console.log('child element NOT FOUND');
    // }
  }

  function removeAllRemoteVideo() {
    console.log(" ---- removeAllRemoteVideo() id");
    consumersStream.current = {};
    setRemoteVideos((peers) => {
      const newPeers = {};

      return { ...newPeers };
    });
    // while (remoteContainer.firstChild) {
    //     remoteContainer.firstChild.pause();
    //     remoteContainer.firstChild.srcObject = null;
    //     remoteContainer.removeChild(remoteContainer.firstChild);
    // }
  }

  const play_pause_timer = (type) => {
    if (isConnectedRef.current) {



      setLoadingTimer(true);

      // this.mediaRecorder.requestData();


      let form = new FormData();
      form.append('processo_id', props.processo.id);
      form.append('user_id', props.student.id);
      form.append('timer', moment().add(seconds_diff.current, 'seconds').format('YYYY-MM-DD HH:mm:ss'));


      // form.append('type', type);



      // const jsZip = new JSZip();
      // jsZip.file('video_' + date_tz + '.webm', recordedBlob);
      // let screenCaptureZipFile = await jsZip.generateAsync({
      //     type: 'blob',
      //     compression: 'DEFLATE',
      //     compressionOptions: {
      //         level: 9
      //     }
      // });

      // lz.compress(recordedBlob.)
      // var reader = new FileReader();
      // reader.readAsDataURL(blob); 
      // reader.onloadend = function() {
      // var base64data = reader.result;                
      //     console.log(base64data);
      // }


      fetch(`${URL}api/avaliador/action_timer`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',

          'Authorization': `Bearer ${token}`,
          // 'Content-Type': 'application/json',
        },
        body: form
      }).then(async (responseLog) => {
        try {
          let resp = await responseLog.json();
          console.log(resp);
          if (resp.message == "Unauthenticated.") {
            localStorage.removeItem('token');
            // this.setState({redirect:true,path:'/'});
            dispatch(logout());
          }
          else if (resp.timers) {
            let candidate = { ...props.student };
            candidate.timers = resp.timers;
            props.changeStudent(candidate);
          }
          setLoadingTimer(false);

        } catch (err) {
          console.log(err);


        }

      })
        .catch((err) => {

          console.log(err);
          // this.props.mudarLoadingHome(false);
        });
    }

  }

  async function consumeAdd(
    transport,
    remoteSocketId,
    prdId,
    trackKind,
    mode = MODE_STREAM
  ) {

  }

  const salvar_stream = (type) => {
    if (isConnectedRef.current) {
      if (type == 'video') {
        init_media_recorder();
      }
      else {
        init_media_recorder_screen();
      }
      // return;
    }




    // this.mediaRecorder.requestData();


    let form = new FormData();
    form.append('processo_id', props.processo.id);
    form.append('student_id', props.student.id);

    form.append('type', type);


    let streamBlob = null;
    if (type == 'video') {
      streamBlob = new Blob(videodata, { type: "video/webm;codecs=h264" });
      videodata = []
    }
    else {
      streamBlob = new Blob(screendata, { type: "video/webm;codecs=h264" });
      screendata = []
    }
    // var reader = new FileReader();
    //       reader.readAsDataURL(streamBlob); 
    //       reader.onloadend = function() {
    //         var base64data = reader.result;                
    //         console.log(base64data);
    //       }
    // const jsZip = new JSZip();
    // jsZip.file('video_' + date_tz + '.webm', recordedBlob);
    // let screenCaptureZipFile = await jsZip.generateAsync({
    //     type: 'blob',
    //     compression: 'DEFLATE',
    //     compressionOptions: {
    //         level: 9
    //     }
    // });

    // lz.compress(recordedBlob.)
    // var reader = new FileReader();
    // reader.readAsDataURL(blob); 
    // reader.onloadend = function() {
    // var base64data = reader.result;                
    //     console.log(base64data);
    // }


    fetch(`${URL}api/avaliador/salvar_stream`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',

        'Authorization': `Bearer ${token}`,
        // 'Content-Type': 'application/json',
      },
      body: form
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');
          // this.setState({redirect:true,path:'/'});
          dispatch(logout());
        }
        else {
          if (resp.url != undefined && streamBlob != null) {
            axios.put(resp.url, streamBlob, {
              headers: {
                "Content-Type": streamBlob.type
              }
            }).then((resp) => {
              console.log(resp)
            }).catch((e) => {
              console.log(e);
            });
          }
          if (resp.timers) {
            // let candidate = { ...props.student };
            console.log('student1231', props.student)
            // candidate.timers = resp.timers;
            props.changeStudent(resp.candidato);
          }
        }

      } catch (err) {
        console.log(err);


      }

    })
      .catch((err) => {

        console.log(err);
        // this.props.mudarLoadingHome(false);
      });
  }

  const init_media_recorder = () => {
    console.log('function init');
    if (mediaRecorder == null) {
      let stream = new MediaStream();
      stream.addTrack(localStream.current.getVideoTracks()[0])
      stream.addTrack(localStream.current.getAudioTracks()[0])
      mediaRecorder = new MediaRecorder(stream, options);
      mediaRecorder.ondataavailable = function (e) {
        videodata.push(e.data);
      };
      mediaRecorder.onstop = async function (e) {
        console.log(e);
        console.log('stopped video')
        mediaRecorder = null;
        salvar_stream('video');
        // this.salvar_dados(id_stream);
      }.bind(this);
      mediaRecorder.start();
      timeout_video_save.current = setTimeout(() => {
        // if (mediaRecorder.state != 'inactive') {
          mediaRecorder.stop();
        // }

      }, props.processo.save_timer);
    }



  }
  const init_media_recorder_screen = () => {
    let video_track = localStream.current.getVideoTracks()[1];

    if (video_track.readyState == 'live') {
      let stream = new MediaStream();
      stream.addTrack(video_track)
      stream.addTrack(localStream.current.getAudioTracks()[0])
      mediaRecorder_2 = new MediaRecorder(stream, options_screen);
      mediaRecorder_2.ondataavailable = function (e) {
        screendata.push(e.data);

      }.bind(this);
      mediaRecorder_2.onstop = async function (e) {
        mediaRecorder_2 = null;
        console.log(e);
        salvar_stream('screen');
      }.bind(this);
      mediaRecorder_2.start();
      timeout_screen_save.current = setTimeout(() => {
        // if (mediaRecorder_2.state != 'inactive') {
          mediaRecorder_2.stop();
        // }

      }, props.processo.save_timer);
    }
    else {
      mediaRecorder_2 = null;
    }


  }

  const onIceCandidate = function (peer, evt, admin_id, receive_id) {
    if (receive_id == 'server') {
      socket.emit("candidate_call_server", JSON.stringify({ "candidate": evt.candidate, sender_id: admin_id, receive_id: receive_id, processo_id: props.processo.id, aluno_id: props.student.id }));
    }
    else {
      socket.emit("candidate_call", JSON.stringify({ "candidate": evt.candidate, sender_id: admin_id, receive_id: receive_id, processo_id: props.processo.id, aluno_id: props.student.id }));
    }
  }

  const handle_offer_sdp = (offer) => {
    console.log('offer')
    console.log(offer)
    return offer.sdp;
    let sdp = offer.sdp.split('\r\n');//convert to an concatenable array
    let new_sdp = '';
    let position = null;
    sdp = sdp.slice(0, -1); //remove the last comma ','
    for (let i = 0; i < sdp.length; i++) {//look if exists already a b=AS:XXX line
      if (sdp[i].match(/b=AS:/)) {
        position = i; //mark the position
      }
    }
    if (position) {
      sdp.splice(position, 1);//remove if exists
    }
    for (let i = 0; i < sdp.length; i++) {
      if (sdp[i].match(/m=video/)) {//modify and add the new lines for video
        new_sdp += sdp[i] + '\r\n' + 'b=AS:' + '256' + '\r\n';
      }
      else {
        if (sdp[i].match(/m=audio/)) { //modify and add the new lines for audio
          new_sdp += sdp[i] + '\r\n' + 'b=AS:' + 48 + '\r\n';
        }
        else {
          new_sdp += sdp[i] + '\r\n';
        }
      }
    }
    return new_sdp; //return the new sdp
  }


  const create_peer = (id) => {
    try {
      // let stream = this.choose_stream(id);

      // if(this.list_peers.current[id]!=undefined && this.list_peers.current[id].connectionState=='connected'){
      //     return;
      // }
      if (list_peers.current[id] != undefined) {
        list_peers.current[id].close();
      }
      list_peers.current[id] = new RTCPeerConnection(configuration);

      list_peers.current[id].onicecandidate = (evt) => {
        if (!evt.candidate) return;
        // console.log("onicecandidate called");
        onIceCandidate(list_peers.current[id], evt, props.getAdminId(), id);
      };
      list_peers.current[id].onaddstream = (evt) => {
        console.log("onaddstream called");
        consumersStream.current[id] = evt.stream;
        console.log('remoteVideos2', remoteVideos, id)
        console.log(participants.current[id])
        participants.current[id].stream = evt.stream;
        participants.current[id].video_track_cam = evt.stream.getVideoTracks()[0];
        participants.current[id].video_track_screen = evt.stream.getVideoTracks()[1];
        participants.current[id].audio_track = evt.stream.getAudioTracks()[0];

        console.log('participant1', participants.current[id])

        let remotes = { ...participants.current };
        setRemoteVideos(remotes)
        // document.getElementById("remoteview").srcObject = evt.stream;
      };
      // list_peers.current[id].oniceconnectionstatechange = function() {
      //     console.log(list_peers.current[id].iceConnectionState);
      // }
      list_peers.current[id].onconnectionstatechange = (e) => {
        console.log(e);
        console.log(list_peers.current[id].connectionState);
      }
      // let stream = new MediaStream();
      // this.props.stream.getTracks().forEach(track => stream.addTrack(track));
      // if(this.props.stream_screen!=null) this.props.stream_screen.getTracks().forEach(track => stream.addTrack(track));
      // this.list_peers.current[id].addStream(localStream.current);
      if (id == 'server') {
        console.log('add track')
        localStream.current.getTracks().forEach(track => list_peers.current[id].addTrack(track, localStream.current));
      }
      else {
        list_peers.current[id].addStream(localStream.current);
      }



      // for (const track of this.props.stream.getTracks()) {
      //     list_peers.current[id].addTrack(track, this.props.stream);
      // }

      list_peers.current[id].createOffer(id == 'server' ? {
        offerToReceiveAudio: 1,
        offerToReceiveVideo: 1
      } : {}).then(function (desc) {
        try {
          // console.log('sdp coonect');
          // if (good == false) {
          desc.sdp = handle_offer_sdp(desc)
          // }
          console.log('peer');

          list_peers.current[id].setLocalDescription(new RTCSessionDescription(desc)).then((s) => {
            // console.log(s);
          }).catch(function (e) {
            console.log('Erro webrtc');
            console.log(e);
            list_peers.current[id].close();
            create_peer(id);
          });
          if (id == 'server') {
            socket.emit("sdp_call_server", JSON.stringify({ "sdp": desc, sender_id: props.getAdminId(), receive_id: id, aluno_id: props.student.id, processo: props.processo.id }));
          }
          else {
            socket.emit("sdp_call", JSON.stringify({ "sdp": desc, sender_id: props.getAdminId(), receive_id: id, aluno_id: props.student.id, processo: props.processo.id }));
          }
        }
        catch (err) {
          // this.create_peer(id);
          console.log(err);
        }

      }).catch(function (e) {
        // console.log(e);
      });
    } catch (e) {
      console.log(e);
    }
  }

  function connect_event(data) {
    console.log('connect_event', 'isConnected', isConnectedRef.current)
    setMessageWarning('');
    if (isConnectedRef.current) {
      socket.emit('join_call', { video_cam: participants.current[props.getAdminId()].video_cam, audio: participants.current[props.getAdminId()].audio, screen: participants.current[props.getAdminId()].screen, type: 'Avaliador', aluno_id: props.student.id, processo_id: props.processo.id, id: props.getAdminId(), name: user.name });
    }
  }

  const focused_participant_ref = useRef();

  useEffect(() => {
    focused_participant_ref.current = focused_participant;
  }, [focused_participant])

  useEffect(() => {
    props.changeShowChatMeet(show_chat);
  }, [show_chat])

  function disconnect_event(data) {
    setMessageWarning('Sua conexão parece estar instável');
  }

  async function handleConnect() {
    if (socket != null && connect == true) {

      setIsStartMedia(false);
      let stream = localStream.current;

      if (!localStream.current) {
        stream = new MediaStream();
        // console.warn("WARN: local media NOT READY");
        // return;
      }
      if (stream.getAudioTracks().length == 0) {
        let track = silence();
        track.stop();
        stream.addTrack(track)
      }
      for (let i = stream.getVideoTracks().length; i < 2; i++) {
        let track = black();
        // track.stop();
        stream.addTrack(track)
      }
      localStream.current = stream;
      consumersStream.current[props.getAdminId()] = localStream.current;
      console.log(socket)
      console.log(localStream.current)

      console.log('connect')
      let participants_ = { ...participants.current };
      participants_[props.getAdminId()] = {
        ...user, id: props.getAdminId(), type: 'Avaliador',
        stream: localStream.current,
        video_track_cam: localStream.current.getVideoTracks()[0],
        video_track_screen: localStream.current.getVideoTracks()[1],
        audio_track: localStream.current.getAudioTracks()[0],
        video_cam: enableVideoStream, audio: enableAudioStream, screen: isShareScreen,
        video_show: 'camera'
      }
      console.log('set remove video4', participants_)
      participants.current = participants_;
      setRemoteVideos(participants_);

      socket.removeAllListeners('join_call');
      socket.removeAllListeners('new_participant');
      socket.removeAllListeners('remove_participant');
      socket.removeAllListeners('candidate_call');
      socket.removeAllListeners('sdp_call');
      socket.removeAllListeners('desc_call');
      socket.removeAllListeners('answer_call');
      socket.removeAllListeners('update_config_call');
      socket.off('connect', connect_event)

      socket.off('disconnect', disconnect_event)

      socket.on('connect', connect_event)

      socket.on('disconnect', disconnect_event)

      socket.on('new_participant', (data) => {
        if (data.id != props.getAdminId()) {

          let participant = { video_show: data.screen == true ? 'screen' : 'camera', type: data.type, id: data.id, name: data.name, stream: null, audio_track: null, video_track_cam: null, video_track_screen: null, video_cam: data.video_cam, audio: data.audio, screen: data.screen };
          let participantes = { ...participants.current };
          participantes[data.id] = participant;
          participants.current = participantes;
          console.log('set remove video1', participantes)
          setRemoteVideos(participantes);
        }


      })

      socket.on('remove_participant', (data) => {
        console.log('removed_participant', data)
        if (data.id != props.getAdminId()) {
          let participantes = { ...participants.current };
          delete participantes[data.id];
          delete consumersStream.current[data.id];
          delete participants.current[data.id];
          list_peers.current[data.id].close();

          console.log('set remove video2', participantes)

          setRemoteVideos(participantes);
          setFocusedParticipant(null);
          if (focused_participant_ref.current != null && focused_participant_ref.current[data.id] != undefined) {
            setFocusedParticipant(null);

          }
        }
      })

      socket.on('update_config_call', (data) => {
        console.log('update_config_call', data)
        data.number.map((item) => {
          let id = item.identifier;
          if (id == props.getAdminId()) {
            return;
          }
          if (participants.current[id].screen == false && item.screen == true) {
            participants.current[id] = { ...participants.current[id], ...item, video_show: 'screen' };
          }
          else {
            participants.current[id] = { ...participants.current[id], ...item };
          }
          let participantes = { ...participants.current };
          setRemoteVideos(participantes);
          if (focused_participant_ref.current != null && focused_participant_ref.current[id] != undefined) {
            setFocusedParticipant({
              [participants.current[id].id]: participants.current[id],
              type:focused_participant_ref.current.type
            });
          }
        })

      })

      socket.on('join_call', (data) => {
        clearTimeout(timeout_join.current);
        console.log('join_call', data);
        // create_peer('server');
        setIsStartMedia(true);
        setIsConnected(true)
        data.number.map((item) => {
          let id = item.identifier;
          let name = item.name;
          if (id != props.getAdminId()) {
            console.log('criando peer', id, props.getAdminId())
            let participant = { video_show: item.screen == true ? 'screen' : 'camera', id, name, type: item.type, stream: null, video_cam: item.video_cam, audio: item.audio, screen: item.screen, audio_track: null, video_track_cam: null, video_track_screen: null };
            participants.current[id] = participant;
            let participantes = { ...participants.current };
            setRemoteVideos(participantes);
            create_peer(id);
          }

        })

      })
      socket.on("candidate_call", function (msg) {
        // console.log("candidate received");
        if (list_peers.current[JSON.parse(msg).sender_id] != undefined && list_peers.current[JSON.parse(msg).sender_id].connectionState != 'closed') {
          list_peers.current[JSON.parse(msg).sender_id].addIceCandidate(new RTCIceCandidate(JSON.parse(msg).candidate));
        }

      });

      socket.on("answer_call", function (answer) {
        // console.log("answer received");
        // console.log(answer);

        list_peers.current[JSON.parse(answer).sender_id].setRemoteDescription(new RTCSessionDescription(JSON.parse(answer).sdp));

        const sender = list_peers.current[JSON.parse(answer).sender_id].getSenders().find(s => s.track && s.track.kind === 'video');

        if (sender) {
          const parameters = sender.getParameters();
          if (!parameters.encodings) {
            parameters.encodings = [{}];
          }

          parameters.encodings[0].maxBitrate = 250_000; // 300 kbps
          parameters.encodings[0].maxFramerate = 10;

          sender.setParameters(parameters)
            .then(() => console.log('Parâmetros de vídeo atualizados'))
            .catch(err => console.error('Erro ao configurar parâmetros de vídeo:', err));
        }
      });

      socket.on("sdp_call", function (msg) {
        console.log("sdp received");
        let id = JSON.parse(msg).sender_id;
        if (list_peers.current[id] != undefined) {
          list_peers.current[id].close();
        }
        list_peers.current[id] = new RTCPeerConnection(configuration);

        list_peers.current[id].onicecandidate = function (evt) {
          if (!evt.candidate) return;
          // console.log("onicecandidate called");
          onIceCandidate(list_peers.current[id], evt, props.getAdminId(), id);
        };

        list_peers.current[id].onaddstream = function (evt) {
          console.log("onaddstream called");
          // if (this.state.sala_select.alunos[id] != undefined) {

          //     this.state.sala_select.alunos[id].videoRef.current.srcObject = evt.stream;
          //     this.state.sala_select.alunos[id].stream = evt.stream;
          //     let user_id = id;
          //     this.audio_context_peers[user_id] = {}
          //     this.audio_context_peers[user_id]['context'] = new AudioContext();
          //     this.audio_context_peers[user_id]['analyser'] = this.audio_context_peers[user_id]['context'].createAnalyser();
          //     this.audio_context_peers[user_id]['frequencyData'] = null;
          //     this.audio_context_peers[user_id]['source'] = this.audio_context_peers[user_id]['context'].createMediaStreamSource(this.state.sala_select.alunos[id].stream);
          //     this.audio_context_peers[user_id]['source'].connect(this.audio_context_peers[user_id]['analyser']);
          //     this.audio_context_peers[user_id]['gainNode'] = this.audio_context_peers[user_id]['context'].createGain();
          //     this.audio_context_peers[user_id]['gainNode'].gain.value = 0.1; // setting it to 10%
          //     this.audio_context_peers[user_id]['gainNode'].connect(this.audio_context_peers[user_id]['context'].destination);
          //     // analyser.connect(context.destination);

          //     this.audio_context_peers[user_id]['context'].resume()
          //     this.audio_context_peers[user_id]['analyser'].fftSize = 32;
          //     this.audio_context_peers[user_id]['bufferLength'] = this.audio_context_peers[user_id]['analyser'].frequencyBinCount;
          //     this.audio_context_peers[user_id]['dataArray'] = new Uint8Array(this.audio_context_peers[user_id]['bufferLength']);
          //     this.audio_context_peers[user_id]['analyser'].getByteTimeDomainData(this.audio_context_peers[user_id]['dataArray']);
          //     this.audio_context_peers[user_id].id=this.uuidv4()
          //     // this.audio.srcObject = evt.stream
          //     this.draw_peer(user_id,this.audio_context_peers[user_id].id);

          //     console.log('full_screen_added1')
          //     // console.log(this.state.aluno_fullscreen,Object.values(this.state.sala_select.alunos)[this.state.aluno_fullscreen]?.id,id)
          //     if (this.state.aluno_fullscreen != -1 && this.state.aluno_fullscreen == id) {
          //         console.log('full_screen_added2')
          //         console.log(evt.stream)
          //         this.fullscreen_ref.current.srcObject = evt.stream;
          //     }
          // }
          consumersStream.current[id] = evt.stream;
          console.log('remoteVideos1', remoteVideos, id)
          participants.current[id].stream = evt.stream;
          participants.current[id].video_track_cam = evt.stream.getVideoTracks()[0];

          participants.current[id].video_track_screen = evt.stream.getVideoTracks()[1];
          participants.current[id].audio_track = evt.stream.getAudioTracks()[0];

          let remotes = { ...participants.current };
          setRemoteVideos(remotes)
          console.log('participant2', participants.current[id])

          // document.getElementById("video_tag" + JSON.parse(msg).aluno_id).srcObject = evt.stream;
        };
        list_peers.current[id].addStream(localStream.current);

        const sender = list_peers.current[id].getSenders().find(s => s.track && s.track.kind === 'video');

        if (sender) {
          const parameters = sender.getParameters();
          if (!parameters.encodings) {
            parameters.encodings = [{}];
          }

          parameters.encodings[0].maxBitrate = 250_000; // 300 kbps
          parameters.encodings[0].maxFramerate = 10;

          sender.setParameters(parameters)
            .then(() => console.log('Parâmetros de vídeo atualizados'))
            .catch(err => console.error('Erro ao configurar parâmetros de vídeo:', err));
        }

        // list_peers.current[id].oniceconnectionstatechange = function() {
        //     console.log(list_peers.current[id].iceConnectionState);
        // }
        // list_peers.current[id].onconnectionstatechange = function() {
        //     console.log(list_peers.current[id].connectionState);
        // }   
        var sessionDesc = new RTCSessionDescription(JSON.parse(msg).sdp);
        list_peers.current[id].setRemoteDescription(sessionDesc);
        list_peers.current[id].createAnswer().then(function (sdp) {
          // if(this.good_quality_student[id]!=true){
          sdp.sdp = handle_offer_sdp(sdp)
          // }
          // else{
          //     console.log('NAO ENTROU SDP')
          // }
          console.log('anwser sdp');
          list_peers.current[id].setLocalDescription(new RTCSessionDescription(sdp));
          socket.emit("answer_call", JSON.stringify({ "sdp": sdp, sender_id: props.getAdminId(), receive_id: id, aluno_id: props.student.id, processo_id: props.processo.id }));
        }).catch(function (e) {
          console.log(e);
        });
      });
      console.log('admin_id1', props.getAdminId())
      console.log('admin_id2', props.getAdminId())
      timeout_join.current = setTimeout(() => {
        setIsStartMedia(true)
      }, 10000);

      socket.emit('join_call', { video_cam: enableVideoStream, audio: enableAudioStream, screen: isShareScreen, type: 'Avaliador', aluno_id: props.student.id, processo_id: props.processo.id, id: props.getAdminId(), name: user.name });
      mediaRecorder = null;

      init_media_recorder();

    }





  }

  async function subscribe() {
    // console.log(socketRef.current);


    // --- get capabilities --

  }

  async function loadDevice(routerRtpCapabilities) {
    try {
      // device.current = new Device();
    } catch (error) {
      if (error.name === "UnsupportedError") {
        console.error("browser not supported");
      }
    }
    await device.current.load({ routerRtpCapabilities });
  }

  function sendRequest(type, data) {

  }

  async function consumeCurrentProducers(clientId) {
    console.log("-- try consuleAll() --");
    const remoteInfo = await sendRequest("getCurrentProducers", {
      localId: clientId,
    }).catch(function (err) {
      console.error("getCurrentProducers ERROR:", err);
      return;
    });
    //console.log('remoteInfo.producerIds:', remoteInfo.producerIds);
    console.log("remoteInfo.remoteVideoIds:", remoteInfo.remoteVideoIds);
    console.log("remoteInfo.remoteAudioIds:", remoteInfo.remoteAudioIds);
    consumeAll(
      consumerTransport.current,
      remoteInfo.remoteVideoIds,
      remoteInfo.remoteAudioIds
    );
  }

  function consumeAll(transport, remoteVideoIds, remotAudioIds) {
    console.log("----- consumeAll() -----");

    remoteVideoIds.forEach((rId) => {
      consumeAdd(transport, rId, null, "video", MODE_STREAM).then((resp) => {
        consumeAdd(transport, rId, null, "video", MODE_SHARE_SCREEN);
      });
    });
    let audioIdsCount = 0;
    remotAudioIds.forEach((rId) => {
      consumeAdd(transport, rId, null, "audio", MODE_STREAM).then((resp) => {
        consumeAdd(transport, rId, null, "audio", MODE_SHARE_SCREEN);
      });
    });
  }

  function disconnectSocket() {
    Object.keys(list_peers.current).map((key) => {
      if (list_peers.current[key] != undefined) {
        list_peers.current[key].close();
      }
    })
    list_peers.current = {}
    participants.current = {}
    consumersStream.current = {}
    setRemoteVideos({});
  }

  function removeConsumer(id, kind, mode) {
    if (mode == undefined) {
      return false;
    }
    if (kind === "video") {
      if (mode == MODE_STREAM) {
        delete videoConsumers.current[id];
      } else {
        delete videoConsumers.current[id][mode];
      }

      console.log(
        "videoConsumers count=" + Object.keys(videoConsumers.current).length
      );
    } else if (kind === "audio") {
      if (mode == MODE_STREAM) {
        delete audioConsumers.current[id];
      } else {
        delete audioConsumers.current[id][mode];
      }

      console.log(
        "audioConsumers count=" + Object.keys(audioConsumers.current).length
      );
    } else {
      console.warn("UNKNOWN consumer kind=" + kind);
    }
  }

  // function getConsumer(id: any, kind: any) {
  //     if (kind === 'video') {
  //         return videoConsumers.current[id];
  //     } else if (kind === 'audio') {
  //         return audioConsumers.current[id];
  //     } else {
  //         console.warn('UNKNOWN consumer kind=' + kind);
  //     }
  // }

  function addConsumer(id, consumer, kind, mode) {
    if (id === clientId.current) {
      return false;
    }
    if (kind === "video") {
      if (videoConsumers.current[id] == undefined) {
        videoConsumers.current[id] = {};
      }
      videoConsumers.current[id][mode] = consumer;
      console.log(
        "videoConsumers count=" + Object.keys(videoConsumers.current).length
      );
    } else if (kind === "audio") {
      if (audioConsumers.current[id] == undefined) {
        audioConsumers.current[id] = {};
      }
      audioConsumers.current[id][mode] = consumer;

      console.log(
        "audioConsumers count=" + Object.keys(audioConsumers.current).length
      );
    } else {
      console.warn("UNKNOWN consumer kind=" + kind);
    }
  }

  const changeVideo = (type, id) => {
    participants.current[id].video_show = type;
    let remotes = { ...participants.current };
    setRemoteVideos(remotes);
  };


  useEffect(() => {
    list_peers.current = {}
    participants.current = {}
    consumersStream.current = {}
    get_time_server();
    return () => {
      clearTimeout(timeout_get_time.current);
      clearTimeout(timeout_increment.current);
      handleDisconnect();
    }
  }, []);

  // call handleDisconnect on component unmount
  // useEffect(() => {
  //   return () => {
  //     handleDisconnect();
  //   };
  // }, []);

  if (!isConnected)
    return (
      <UserInfoForm
        {...{
          roomName,
          handleRoomName,
          handleConnect,
          isStartMedia,
          username,
          handleUsername,

          // media control
          handleStartMedia,
          devicesMic,
          devicesCam,
          deviceCamSelect,
          deviceMicSelect,
          setDeviceCamSelect,
          setDeviceMicSelect,
          setDevicesCam,
          setDevicesMic,
          localVideo,
          // streaming control
          localStream,
          enableVideoStream,
          handleEnableVideoStream,
          enableAudioStream,
          handleEnableAudioStream,
          ...props
        }}
      />
    );

  return (
    <div
      className={"Transition-1 avaliador-meet-page " + ((localStorage.getItem('avaliador_theme') || 'light') == 'dark' ? 'dark-mode' : 'white-mode')}
      style={{
        height: "100vh",
        width: "100vw",
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: "hidden",
        display: "grid",
        // gridTemplateColumns: "1fr 30rem",
        gridTemplateColumns:
          show_chat || show_participants || show_info ? "1fr 30rem" : "1fr 0rem",
        background: "var(--background-color1)",
        color: "var(--text-color2)",
      }}
    >
      <VideoArea
        {...{
          participants:
            focused_participant === null ? remoteVideos : focused_participant,
          focused_participant,
          setFocusedParticipant,
          playVideo,
          getAdminId: props.getAdminId,
          messageWarning: messageWarning,
          // streaming control
          localStream,
          enableVideoStream,
          handleEnableVideoStream,
          enableAudioStream,
          handleEnableAudioStream,
          // share screen control
          localScreen,
          localStreamScreen,
          isShareScreen,
          handleStartScreenShare,
          handleDisconnectScreenShare,

          handleDisconnect,
          students: props.students,
          id_candidato: props.id_candidato,

          // right content control
          show_info,
          setShowInfo,
          show_chat,
          setShowChat,
          show_participants,
          setShowParticipants,
          get_messages_from_student: props.get_messages_from_student

        }}
      />
      <RightContentWrapper
        {...{
          changeVideo,
          participants: remoteVideos,
          focused_participant,
          setFocusedParticipant,
          send_message: props.send_message,
          students: props.students,
          show_info,
          setShowInfo,
          entrevistas: props.entrevistas,
          show_chat,
          setShowChat,
          show_participants,
          setShowParticipants,
          changeStudent: props.changeStudent,
          playVideo,
          getAdminId: props.getAdminId,
          id_candidato: props.id_candidato,
          get_messages_from_student: props.get_messages_from_student,
          play_pause_timer,
          loading_timer
        }}
      />
    </div>
  );
}
